module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}


//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/util/support/isBufferBrowser.js
// module id = ../../../node_modules/util/support/isBufferBrowser.js
// module chunks = 1